import "./styles.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { useTabHighlight } from "./useTabHighlight";

interface TabSwitcherProps {
  activeTab: string;
  onChange: (tabId: string) => void;
}

function TabSwitcher({ activeTab, onChange }: TabSwitcherProps) {
  const { t } = useTranslation();

  const tabs: { id: string; label: string }[] = [
    {
      id: "leverages",
      label: t("frontend.test.analyticsResults.leverages", "Leverages"),
    },
    { id: "all", label: t("frontend.test.analyticsResults.all", "All") },
    {
      id: "challenges",
      label: t("frontend.test.analyticsResults.challenges", "Challenges"),
    },
  ];

  const containerRef = useRef<HTMLDivElement>(null);
  const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 });
  const activeButtonRef = useRef<HTMLButtonElement | null>(null);

  useTabHighlight({ containerRef, activeButtonRef, setHighlightStyle });

  return (
    <div className="tab-switcher" ref={containerRef}>
      <div
        className="tab-highlight"
        style={{
          transform: `translateX(${highlightStyle.left}px)`,
          width: `${highlightStyle.width}px`,
        }}
      />
      {tabs.map(({ id, label }) => (
        <button
          ref={activeTab === id ? activeButtonRef : null}
          key={id}
          data-id={id}
          onClick={() => onChange(id)}
          className={classNames("tab-button", {
            active: activeTab === id,
          })}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default TabSwitcher;
